import { pageSummaryInfo as pageSummaryProps } from "../others/common.interfaces";
import Img from "./Img";


const PageSummary = ({ bgImage, title, description, socialMedia }: pageSummaryProps): JSX.Element => {
    return (
        <section className="relative h-64 overflow-hidden">
            <div className="z-20 maxw  sm:flex-row  h-full flex flex-col gap-0 items-end text-white py-3 px-7 justify-between">
                <div className="flex flex-col">
                    <h1 className="text-2xl">{title}</h1>
                    <p className="mb-7 w-full sm:w-[70%]">{description}</p>
                </div>
                {
                    socialMedia && <div className="flex items-center gap-3 pb-7 z-20">
                        {
                            socialMedia.map((medium, i) => {
                                return (
                                    <a href={medium.link} key={'SocialMedia-' + i}>
                                        <Img src={medium.icon} alt="SocialMediaIcon" height={24} width={24} className="min-h-[24px] min-w-[24px]" />
                                    </a>
                                )
                            })
                        }
                    </div>
                }
            </div>
            <Img
                src={bgImage}
                alt={'PageSummary background'}
                className="absolute top-0 left-0 h-64 w-full brightness-75 -z-10"
            />
            <Img
                src="/mosaic.svg"
                alt="Mosaic"
                height={'100%'}
                width={200}
                className="absolute top-0 right-0 z-10 lg:w-[250px]"
            />

        </section>
    )
}

export default PageSummary